/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UmbrellaFreelancerRequestStateResource = {
    Refused: 'REFUSED',
    Accepted: 'ACCEPTED'
} as const;
export type UmbrellaFreelancerRequestStateResource = typeof UmbrellaFreelancerRequestStateResource[keyof typeof UmbrellaFreelancerRequestStateResource];


export function instanceOfUmbrellaFreelancerRequestStateResource(value: any): boolean {
    for (const key in UmbrellaFreelancerRequestStateResource) {
        if (Object.prototype.hasOwnProperty.call(UmbrellaFreelancerRequestStateResource, key)) {
            // @ts-ignore
            if (UmbrellaFreelancerRequestStateResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UmbrellaFreelancerRequestStateResourceFromJSON(json: any): UmbrellaFreelancerRequestStateResource {
    return UmbrellaFreelancerRequestStateResourceFromJSONTyped(json, false);
}

export function UmbrellaFreelancerRequestStateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaFreelancerRequestStateResource {
    return json as UmbrellaFreelancerRequestStateResource;
}

export function UmbrellaFreelancerRequestStateResourceToJSON(value?: UmbrellaFreelancerRequestStateResource | null): any {
    return value as any;
}

